import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import appMessages from "core/app/intl/AppMessages";
import { isNavItemVisible, matchPath } from "core/shared/util/sideNavUtils";
import MenuItem from "core/app/presenter/sideNav/SideNavMenuItem";
import { StSubNavContainer } from "core/app/presenter/sideNav/SideNavStyles";

const SubMenuList = React.memo(
  ({
    expanded,
    hasFeatureFlag,
    isLegacyPlatform,
    location,
    onSelect,
    subMenu,
    toggleSubMenu,
  }) => {
    const { formatMessage } = useIntl();

    return (
      <StSubNavContainer expanded={expanded}>
        {subMenu.map((item) => {
          const {
            beta,
            flag,
            intlKey,
            isExternal,
            isSmartLink,
            key,
            legacy,
            matches,
          } = item;

          if (
            !isNavItemVisible({
              isLegacyPlatform,
              legacy,
              hasFeatureFlag,
              flag,
            })
          )
            return null;

          return (
            <MenuItem
              key={key}
              active={matchPath({ location, matches })}
              beta={beta || legacy}
              betaLabel={
                (beta && formatMessage(appMessages.beta)) ||
                (legacy && formatMessage(appMessages.legacy))
              }
              data={item}
              isExternal={isExternal}
              isSmartLink={isSmartLink}
              label={formatMessage(intlKey)}
              onSelect={onSelect}
              sub
              toggleClick={toggleSubMenu}
            />
          );
        })}
      </StSubNavContainer>
    );
  }
);

const subItemShape = PropTypes.shape({
  beta: PropTypes.bool,
  flag: PropTypes.string,
  intlKey: PropTypes.shape({
    id: PropTypes.string.isRequired,
    defaultMessage: PropTypes.string,
  }).isRequired,
  isExternal: PropTypes.bool,
  isSmartLink: PropTypes.bool,
  key: PropTypes.string.isRequired,
  legacy: PropTypes.bool,
  matches: PropTypes.arrayOf(PropTypes.string).isRequired,
});

SubMenuList.displayName = "SubMenuList";
SubMenuList.propTypes = {
  expanded: PropTypes.bool.isRequired,
  hasFeatureFlag: PropTypes.func.isRequired,
  isLegacyPlatform: PropTypes.bool.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  onSelect: PropTypes.func.isRequired,
  subMenu: PropTypes.arrayOf(subItemShape).isRequired,
  toggleSubMenu: PropTypes.func.isRequired,
};

export default SubMenuList;
